import { Box, VStack, useColorModeValue, Icon } from '@chakra-ui/react'
import { MdEmail } from 'react-icons/md'
import { useTranslation } from 'react-i18next'

export default function CheckEmail() {
  const { t } = useTranslation()
  const formBg = useColorModeValue('white', 'gray.800')
  const formBorder = useColorModeValue('gray.100', 'gray.700')
  const titleColor = useColorModeValue('gray.700', 'gray.200')
  const subTitleColor = useColorModeValue('gray.600', 'gray.300')
  const iconBg = useColorModeValue('purple.50', 'purple.900')

  return (
    <Box
      w="100%"
      maxW={480}
      mx="auto"
    >
      <VStack spacing={4} w="100%">
        <Box textAlign="center" w="100%">
          <Box
            fontSize={{ base: 'xl', md: '2xl' }}
            fontWeight="600"
            color={titleColor}
            mb={4}
          >
            {t('auth.welcomeCareflai')}
          </Box>
          <Box
            fontSize={{ base: 'lg', md: 'xl' }}
            fontWeight="600"
            color={titleColor}
            mb={2}
          >
            {t('auth.checkEmail.title')}
          </Box>
          <Box
            fontSize={{ base: 'sm', md: 'md' }}
            color={subTitleColor}
          >
            {t('auth.checkEmail.subtitle')}
          </Box>
        </Box>

        <Box
          w="100%"
          bg={formBg}
          p={{ base: 8, md: 10 }}
          borderRadius="xl"
          boxShadow="xl"
          borderWidth="1px"
          borderColor={formBorder}
          transition="all 0.3s"
          textAlign="center"
        >
          <VStack spacing={6}>
            <Box
              bg={iconBg}
              borderRadius="full"
              p={6}
              display="inline-flex"
            >
              <Icon
                as={MdEmail}
                w={16}
                h={16}
                color="purple.500"
              />
            </Box>

            <Box>
              <Box
                fontSize={{ base: 'lg', md: 'xl' }}
                fontWeight="600"
                color={titleColor}
                mb={3}
              >
                {t('auth.checkEmail.checkInbox')}
              </Box>
              <Box
                fontSize={{ base: 'sm', md: 'md' }}
                color={subTitleColor}
                lineHeight="tall"
              >
                {t('auth.checkEmail.description')}
              </Box>
            </Box>

            <Box
              w="100%"
              pt={4}
              borderTopWidth="1px"
              borderColor={formBorder}
            >
              <Box
                fontSize="sm"
                color={subTitleColor}
                mb={2}
              >
                {t('auth.checkEmail.notReceived')}
              </Box>
              <Box
                fontSize="xs"
                color={subTitleColor}
              >
                {t('auth.checkEmail.checkSpam')}
              </Box>
            </Box>
          </VStack>
        </Box>
      </VStack>
    </Box>
  )
}
